import { find, get, isEmpty, map, size } from "lodash";

import { fetchSchedules } from "./schedule.actions";
import { fetchSongsAccrodingToReaction } from "./songs.actions";
import { fetchCustomerData } from "./user.actions";
import { fetchPlaylistById } from "./playlist.actions";

export const fetchAppData = async (user_id, userOffline) => {
  if (userOffline) {
    return;
  }
  const [
    customerData,
    likedSongs,
    dislikedSongs,
    ignoredSongs,
    favouriteSongs,
    schedules,
  ] = await Promise.allSettled([
    fetchCustomerData(user_id),
    fetchSongsAccrodingToReaction("LIKE"),
    fetchSongsAccrodingToReaction("DISLIKE"),
    fetchSongsAccrodingToReaction("IGNORE"),
    fetchSongsAccrodingToReaction("FAVORITE"),
    fetchSchedules(),
  ]);

  const { user, playlists, status, transactions } = customerData.value;

  let playlist_id = status?.last_played_playlist;

  if (!status?.last_played_playlist) {
    //* fetch favourite playlist
    playlist_id = find(playlists, (playlist) => {
      return get(playlist, "is_favourite", false) && size(playlist.songs) !== 0;
    });
    // ?.id;
  }

  if (isEmpty(playlist_id)) {
    playlist_id =
      find(playlists, (playlist) => size(playlist.songs) !== 0)?.id ||
      playlists?.[0]?.id;
  }

  const favoritePlaylist = await fetchPlaylistById(playlist_id);

  //* updated schdules
  const schedulesValue = schedules.value;

  const newSchedules = map(schedulesValue, (schedule) => {
    const playlist = find(
      playlists,
      (playlist) => get(playlist, "id", "") === get(schedule, "playlist_id", "")
    );

    return {
      ...schedule,
      name: get(playlist, "name", ""),
      thumbnail_img: get(playlist, "thumbnail_img", ""),
      // color: playlist.color,
    };
  });

  // // loop through liked and disliked songs and make one array of object of ids : true or false(liked songs true)
  // const likedSongsIds = map(likedSongs.value, (song) => song.id);
  // const dislikedSongsIds = map(dislikedSongs.value, (song) => song.id);

  // const likedAndDislikedSongs = {
  //   ...likedSongsIds.reduce((acc, id) => {
  //     acc[id] = true;
  //     return acc;
  //   }, {}),
  //   ...dislikedSongsIds.reduce((acc, id) => {
  //     acc[id] = false;
  //     return acc;
  //   }, {}),
  // };

  // const [customerData, likedSongs] = await Promise.allSettled([
  //   fetchCustomerData(user.id || ""),
  //   fetchLikedSongs(),
  // ]);
  // setLikedSongs(likedSongs.value);

  // const { customer, playlists, status } = customerData.value;

  // if (!isEmpty(customer)) setUser(customer);
  // if (!isEmpty(playlists)) setPlaylists(playlists);
  // if (!isEmpty(songsData.value)) {
  //   const songs = getFormattedSongs(songsData.value);
  //   const musicPlayerSongs = getFormattedSongs(playlists?.[0]?.songs || []);

  //   const initialShuffleState = status?.last_shuffle || false;
  //   const musicPlayerSongsToSet = initialShuffleState
  //     ? shuffleArray([...musicPlayerSongs], 0)
  //     : musicPlayerSongs;

  //   if (initialShuffleState) {
  //     setBeforeShuffleSongs([...musicPlayerSongs]);
  //   }

  //   toggleIsShuffle(initialShuffleState);
  //   setSongs(songs);
  //   setMusicPlayerSongs(musicPlayerSongsToSet);
  //   setPlayList(playlists[0]);
  //   // get song.id if song.ignore is true
  //   const ingoreSongIds = getIngoreSongIds(playlists);
  //   setIgnoredSongs(ingoreSongIds);
  // }

  return {
    user: {
      ...user,
      transactions,
    },
    playlists,
    status,
    likedSongs: likedSongs.value,
    dislikedSongs: dislikedSongs.value,
    ignoredSongs: ignoredSongs.value,
    favouriteSongs: favouriteSongs.value,
    schedules: newSchedules,
    favoritePlaylist,
  };
};
